import {
    CREATE_FABRIC_INWARD_DETAILS_FAILURE,
    CREATE_FABRIC_INWARD_DETAILS_REQUEST,
    CREATE_FABRIC_INWARD_DETAILS_SUCCESS,
    CREATE_USER_FORM_FABRIC_INWARD_DETAILS,
    DELETE_FABRIC_INWARD_DETAILS_FAILURE,
    DELETE_FABRIC_INWARD_DETAILS_REQUEST,
    DELETE_FABRIC_INWARD_DETAILS_SUCCESS,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST,
    FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS,
    FETCH_FABRIC_INWARD_DETAILS_FAILURE,
    FETCH_FABRIC_INWARD_DETAILS_REQUEST,
    FETCH_FABRIC_INWARD_DETAILS_SUCCESS,
    FABRIC_INWARD_DETAILS_USERFORM_RESET,
    UPDATE_FABRIC_INWARD_DETAILS_FAILURE,
    UPDATE_FABRIC_INWARD_DETAILS_REQUEST,
    UPDATE_FABRIC_INWARD_DETAILS_SUCCESS,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS,
    FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE,
    FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_SUCCESS,
    FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_REQUEST,
    FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_FAILURE,
    FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_REQUEST,
    FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_SUCCESS,
    FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_FAILURE,
    FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED
} from './fabricInwardDetails.actionsType';

export const FABRIC_INWARD_DETAILS = 'fabricInwardDetails';

let initialState = {
    loading: false,
    fabricInwardDetailsById: [],
    fabricInwardDetails: [],
    SOAndSNGetList: [],
    previousGetList: [],
    fabricInwardDetailsForm: {
        fldItemRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0,
        fldSGSTPercentage: 0,
        fldDiscountPercentage: 0
    },
    isPoDetailsDisabled: false,
    selectedFabricDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let fabricInwardDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_FABRIC_INWARD_DETAILS_REQUEST:
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_REQUEST:
        case CREATE_FABRIC_INWARD_DETAILS_REQUEST:
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_REQUEST:
        case UPDATE_FABRIC_INWARD_DETAILS_REQUEST:
        case DELETE_FABRIC_INWARD_DETAILS_REQUEST:
        case FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_REQUEST:
        case FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardDetails: updatePayload
            };
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsById: updatePayload
            };
        case FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_SUCCESS:
            return {
                ...state,
                loading: false,
                SOAndSNGetList: updatePayload
            };
        case FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                previousGetList: updatePayload
            };
        case CREATE_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: updatePayload,
                fabricInwardDetailsForm: {
                    ...updatePayload
                }
            };
        case UPDATE_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedFabricDetails: {},
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                isPoDetailsDisabled: false
            };
        case DELETE_FABRIC_INWARD_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedFabricDetails: {},
                isPoDetailsDisabled: false
            };

        case FETCH_FABRIC_INWARD_DETAILS_FAILURE:
        case FETCH_SINGLE_FABRIC_INWARD_DETAILS_FAILURE:
        case CREATE_FABRIC_INWARD_DETAILS_FAILURE:
        case UPDATE_FABRIC_INWARD_DETAILS_FAILURE:
        case DELETE_FABRIC_INWARD_DETAILS_FAILURE:
        case FETCH_FABRIC_INWARD_DETAILS_BY_ID_FAILURE:
        case FETCH_FABRIC_INWARD_DETAILS_SO_AND_SN_FAILURE:
        case FETCH_PREVIOUS_FABRIC_INWARD_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_FABRIC_INWARD_DETAILS:
            return {
                ...state,
                loading: false,
                fabricInwardDetailsForm: {
                    ...state.fabricInwardDetailsForm,
                    [payload.key]: payload.value
                }
            };
        case FABRIC_INWARD_DETAILS_PO_DETAILS_DISABLED:
            return {
                ...state,
                isPoDetailsDisabled: payload
            };
        case FABRIC_INWARD_DETAILS_USERFORM_RESET:
            return {
                ...state,
                fabricInwardDetailsForm: {
                    fldItemRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldSGSTPercentage: 0,
                    fldDiscountPercentage: 0
                },
                selectedFabricDetails: {},
                isPoDetailsDisabled: false
            };
        default:
            return state;
    }
};
